import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { filter, take } from 'rxjs/operators'
import { isSomething } from '@tokeet-frontend/tv3-platform'
import { AirbnbListingPromotionProgramStatus } from '@tokeet-frontend/channels'
import { Connection } from '@tv3/store/connection/connection.model'
import { AirbnbBlackoutDatesDialogComponent } from './airbnb-blackout-dates-dialog.component'

@Injectable({
  providedIn: SharedModule,
})
export class AirbnbBlackoutDatesDialogService {
  constructor(private dialog: MatDialog) {}

  // Emits the discount status that Airbnb returns after a save.
  public open(connection: Connection, discount: AirbnbListingPromotionProgramStatus) {
    const defaultConfig: MatDialogConfig = {
      width: '640px',
      height: 'auto',
      data: { connection, discount },
      panelClass: ['fixed-modal'],
    }

    return this.dialog
      .open<AirbnbBlackoutDatesDialogComponent, any, AirbnbListingPromotionProgramStatus>(
        AirbnbBlackoutDatesDialogComponent,
        defaultConfig
      )
      .afterClosed()
      .pipe(
        take(1),
        filter((res) => isSomething(res))
      )
  }
}
